export default "__VITE_ASSET__WMj0bD3f__"